import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { realEstate } from 'fetchers/realEstateApi';
import { useRecoilValue } from 'recoil';
import { aptIdSelector } from 'atoms';
import { useMutation, useQueryClient } from 'react-query';

const RealEstateNewModal = ({ setIsRealEstateNewModalOpen }) => {
  const queryClient = useQueryClient();
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [file, setFiles] = useState([]);
  const [isAttatch, setIsAttach] = useState(false);
  const aptId = useRecoilValue(aptIdSelector);

  const inputFileRef = useRef(null);

  const { mutate } = useMutation(
    (formData) => realEstate.registerData(formData),
    {
      onSuccess: () => {
        setIsRealEstateNewModalOpen(false);
        queryClient.invalidateQueries('realEstate');
      },
      onError: (response) => window.alert(response.error.message),
    },
  );

  const handleAddPhoto = () => {
    inputFileRef.current.click();
  };

  const handleRemovePhoto = () => {
    setImagePreviewUrl(
      'https://resource.aptstory.com/images/content/img-empty-realestate.svg',
    );
    inputFileRef.current.value = '';
    setIsAttach((prev) => !prev);
  };

  const uploadFileHandler = (e) => {
    const reader = new FileReader();
    const imageFile = e.target.files[0];
    reader.onloadend = () => setImagePreviewUrl(reader.result);
    reader.readAsDataURL(imageFile);
    setFiles(imageFile);
    setIsAttach(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('file', file);
    formData.append('aptId', aptId);
    formData.append('realestateName', e.target[1].value);
    formData.append('providerName', e.target[2].value);
    formData.append('address', e.target[3].value);
    formData.append('homepage', e.target[4].value);
    formData.append('phone', e.target[5].value);

    mutate(formData);
  };

  return (
    <RealEstateModalComponent className='fixed-bottom'>
      <RealEstateModalRegisterComponent className='fixed-bottom'>
        <RealEstateModalRegisterTitleComponent className='row position-relative mx-0 border-bottom border-bottom-2 border-gray-800'>
          <div className='col-12 pt-4 pb-3 text-center'>
            <RealEstateModalRegisterTitle className='font-weight-bold'>
              업체정보
            </RealEstateModalRegisterTitle>
          </div>
          <RealEstateModalRegisterCloseButton
            className='position-absolute right-5'
            onClick={() => setIsRealEstateNewModalOpen(false)}
          >
            <button className='btn btn-link pt-4'>
              <Icon className='bi bi-x-lg small' />
            </button>
          </RealEstateModalRegisterCloseButton>
        </RealEstateModalRegisterTitleComponent>
        <RealEstateModalRegisterList
          className='d-flex flex-column'
          onSubmit={handleSubmit}
        >
          <RealEstateModalRegisterInputContainer className='d-flex flex-row align-items-center justify-content-center py-4'>
            <RealEstateModalRegisterFileUploadWrapper className='d-flex flex-row align-items-center justify-content-center'>
              <RealEstateModalRegisterFileUploadImage
                className='card-img thumbnail-sm rounded-circle'
                src={
                  imagePreviewUrl
                    ? imagePreviewUrl
                    : 'https://resource.aptstory.com/images/content/img-empty-realestate.svg'
                }
                onClick={handleAddPhoto}
              />
              {!isAttatch ? (
                <RealEstateModalRegisterFileUploadIcon className='i-photo-add' />
              ) : (
                <RealEstateModalRegisterFileUploadIcon
                  className='i-photo-delete'
                  onClick={handleRemovePhoto}
                />
              )}
              <RealEstateModalRegisterFileUploadInput
                type='file'
                ref={inputFileRef}
                onChange={uploadFileHandler}
                style={{ display: 'none' }}
              />
            </RealEstateModalRegisterFileUploadWrapper>
          </RealEstateModalRegisterInputContainer>
          <div className='container-fluid'>
            <RealEstateModalRegisterInputContainer className='row mx-0 align-items-center border-bottom'>
              <div className='col-4 col-md-3 px-0 py-2'>
                <RealEstateModalRegisterInputTitle className='text-gray-600'>
                  업체명
                </RealEstateModalRegisterInputTitle>
              </div>
              <div className='col-8 col-md-9 px-0 py-2'>
                <RealEstateModalRegisterInput
                  className='form-control'
                  placeholder='예)OOO부동산'
                />
              </div>
            </RealEstateModalRegisterInputContainer>
            <RealEstateModalRegisterInputContainer className='row mx-0 align-items-center border-bottom'>
              <div className='col-4 col-md-3 px-0 py-2'>
                <RealEstateModalRegisterInputTitle className='text-gray-600'>
                  대표자명
                </RealEstateModalRegisterInputTitle>
              </div>
              <div className='col-8 col-md-9 px-0 py-2'>
                <RealEstateModalRegisterInput
                  className='form-control'
                  placeholder='예) 홍길동'
                />
              </div>
            </RealEstateModalRegisterInputContainer>
            <RealEstateModalRegisterInputContainer className='row mx-0 align-items-center border-bottom'>
              <div className='col-4 col-md-3 px-0 py-2'>
                <RealEstateModalRegisterInputTitle className='text-gray-600'>
                  업체주소
                </RealEstateModalRegisterInputTitle>
              </div>
              <div className='col-8 col-md-9 px-0 py-2'>
                <RealEstateModalRegisterInput className='form-control' />
              </div>
            </RealEstateModalRegisterInputContainer>
            <RealEstateModalRegisterInputContainer className='row mx-0 align-items-center border-bottom'>
              <div className='col-4 col-md-3 px-0 py-2'>
                <RealEstateModalRegisterInputTitle className='text-gray-600'>
                  홈페이지
                </RealEstateModalRegisterInputTitle>
              </div>
              <div className='col-8 col-md-9 px-0 py-2'>
                <RealEstateModalRegisterInput className='form-control' />
              </div>
            </RealEstateModalRegisterInputContainer>
            <RealEstateModalRegisterInputContainer className='row mx-0 align-items-center'>
              <div className='col-4 col-md-3 px-0 py-2'>
                <RealEstateModalRegisterInputTitle className='text-gray-600'>
                  전화번호
                </RealEstateModalRegisterInputTitle>
              </div>
              <div className='col-8 col-md-9 px-0 py-2'>
                <RealEstateModalRegisterInput
                  className='form-control'
                  placeholder='010-0000-0000'
                />
              </div>
            </RealEstateModalRegisterInputContainer>
          </div>
          <RealEstateModalRegisterButtonContainer className='btn-group'>
            <div className='col-5 px-0'>
              <RealEstateModalRegisterCancelButton
                className='btn btn-gray-200 btn-block btn-lg rounded-0 text-gray-500'
                onClick={() => setIsRealEstateNewModalOpen(false)}
              >
                닫기
              </RealEstateModalRegisterCancelButton>
            </div>
            <div className='col-7 px-0'>
              <RealEstateModalRegisterConfirmButton className='btn btn-primary btn-block btn-lg rounded-0'>
                저장
              </RealEstateModalRegisterConfirmButton>
            </div>
          </RealEstateModalRegisterButtonContainer>
        </RealEstateModalRegisterList>
      </RealEstateModalRegisterComponent>
    </RealEstateModalComponent>
  );
};

const RealEstateModalComponent = styled.section`
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

const RealEstateModalRegisterComponent = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 0.3rem 0.3rem 0 0;
  background-color: white;
  overflow: auto;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

const RealEstateModalRegisterTitleComponent = styled.div``;
const RealEstateModalRegisterTitle = styled.h3``;
const RealEstateModalRegisterCloseButton = styled.div``;
const RealEstateModalRegisterList = styled.form``;
const RealEstateModalRegisterInputContainer = styled.div``;
const RealEstateModalRegisterInputTitle = styled.h5``;
const RealEstateModalRegisterInput = styled.input``;
const RealEstateModalRegisterFileUploadWrapper = styled.div`
  position: relative;
`;
const RealEstateModalRegisterFileUploadImage = styled.img``;
const RealEstateModalRegisterFileUploadIcon = styled.i`
  position: absolute;
  top: 62.5%;
  right: 0;
`;
const RealEstateModalRegisterFileUploadInput = styled.input``;

const RealEstateModalRegisterButtonContainer = styled.div``;
const RealEstateModalRegisterCancelButton = styled.button``;
const RealEstateModalRegisterConfirmButton = styled.button``;

const Icon = styled.i``;

export default RealEstateNewModal;
